<template>
  <a-modal
    :title="upload.title"
    :visible="excelVisible"
    destroyOnClose
    @cancel="importExcelHandleCancel"
  >
    <p><a href="javascript:;" v-if="templateConfig.templateUrl" @click="onDownTemplate">下载模板</a></p>
    <a-upload-dragger
      name="file"
      accept=".xlsx, .xls"
      :multiple="true"
      :headers="upload.headers"
      :action="upload.url"
      @change="onChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">请将文件拖拽到此处上传</p>
      <p class="ant-upload-hint">支持单个或批量上传，也可以点击后选择文件上传</p>
    </a-upload-dragger>
    <div class="footer-box" slot="footer">
      <a-button @click="importExcelHandleCancel">关闭</a-button>
    </div>
  </a-modal>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'ImportModal',
  components: {},
  data() {
    const token =
      process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
        ? localStorage.getItem('token')
        : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: ''
      },
      excelVisible: false,
      templateConfig: {
        templateName: '',
        templateUrl: ''
      }
    }
  },
  methods: {
    show(config = {}) {
      const { title = '导入Excel', url = '', templateName, templateUrl } = config;
      this.upload.title = title;
      this.upload.url = process.env.VUE_APP_API_BASE_URL + url;
      this.excelVisible = true;
      this.templateConfig = {
        templateName, templateUrl
      }
    },
    onChange(action) {
      console.log(action)
      const status = action.file.status;
      const resCode = action.file?.response?.code;
      if (status === 'done') {
        if(resCode === 200) {
          this.$message.success(`${action.file.name}: ${action.file.response.msg}`)
          this.$emit('successCall', action)
        }else {
          this.$message.error(`${action.file.name}: ${action.file.response.msg}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${action.file.name}: ${action.file.response.msg}`)
      }
      this.$emit('onChange', action);
    },
    importExcelHandleCancel() {
      this.excelVisible = false;
    },
    /** 下载模板操作 */
    onDownTemplate() {
      this.download(this.templateConfig.templateUrl, {}, `${this.templateConfig.templateName}_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style lang="less" scoped>
.footer-box {
  text-align: right;
}
</style>
